<template>
  <span id="wishlist-list-title">
    <span v-html="titlePage" class="title"></span>
    <span v-html="countItems" class="count"></span>
    /
    <template v-if="getPageWishes()">
      <span class="title2" @click="onWishesModerate()">На проверку</span>
    </template>
    <template v-else-if="getPageWishesModerate()">
      <span class="title2" @click="onWishes()">Желания</span>
    </template>
  </span>
</template>

<script setup>
import {computed, defineOptions} from "vue"
import {useRouter} from "vue-router"

defineOptions({
  name: "WishlistWishHeader1"
})

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const router = useRouter()

const titlePage = computed(() => {
  return props.data?.['title_page'] || ""
})

const countItems = computed(() => {
  const count = props.data?.['count_items']

  if (count > 0) {
    return `: <span>${count}</span>`
  }

  return ""
})

function getPageWishes() {
  return props.data['page'] === "wishes"
}

function getPageWishesModerate() {
  return props.data['page'] === "wishes_moderate"
}

function onWishes() {
  return router.push({name: "WishlistWishes"})
}

function onWishesModerate() {
  return router.push({name: "WishlistWishesModerate"})
}
</script>

<style scoped src="./style.css" />
